import {createGetHook} from "services/http/hooks";
import {Country} from "../../../types/global";

// Static GET: Countries
export const useGetCountriesQuery = createGetHook<Country[]>("/countries");
